import { Schema } from "effect";
export const Conference = Schema.Struct({
    iId: Schema.NonEmptyString,
    conferenceId: Schema.String,
    tollNumber: Schema.String,
    meetingId: Schema.String,
});
